import { render } from "./BookForm.vue?vue&type=template&id=3f910fda&scoped=true"
import script from "./BookForm.vue?vue&type=script&lang=js"
export * from "./BookForm.vue?vue&type=script&lang=js"

import "./BookForm.vue?vue&type=style&index=0&id=3f910fda&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f910fda"]])

export default __exports__